import React from "react"
import useTargetStorage from "@/hooks/useTargetStorage"
import { useTranslation } from "react-i18next"
import { useNavigate, useParams } from "react-router-dom"
import useCustomers from "hooks/useCustomers"
import useStorages from "hooks/useStorages"
import EditCustomerForm from "features/storages/customers/editCustomerForm"
import SectionHeader from "@/components/layout/sectionHeader"
import Section from "@/components/layout/section"
import SectionHeaderTitle from "@/components/layout/sectionHeaderTitle"
import PageTitle from "features/navigation/pageTitle"
import { paramGuardStorage, paramGuardCustomer } from "@/utils/paramGuard"
import { FormStatus } from "@/types"
import RightSidebarCustomer from "@/components/sidebar/right/RightSidebarCustomer"

const EditCustomer: React.FC = () => {
    
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { targetStorageDocId: storageId } = useTargetStorage()
    const { customerId } = useParams<{ customerId: string }>()
    
    const {
        customer,
        customerStatus
    } = useCustomers({ storageId, customerId })

    const { 
        storage,
        storageStatus,
        isCustomersEnabled
    } = useStorages({ storageId })

    // Check params and declare safe ones to use in JSX
    if (
        !paramGuardStorage({storageId, storage, storageStatus, navigate}) ||
        !paramGuardCustomer({storageId, customerId, customer, customerStatus, navigate})
    ) {
        return <></>
    }
    const safeStorageId = storageId!;
    const safeCustomerId = customerId!;

    // Redirect if customers are disabled for this storage
    if (!isCustomersEnabled()) {
        navigate(`/storage`);
        return <></>;
    }

    return (
        <>
            <PageTitle title={t('titleEditCustomer')} />
            <Section>
                <EditCustomerForm 
                    customer={customer!}
                    storageId={safeStorageId}
                    customerId={safeCustomerId}
                />
            </Section>
            <RightSidebarCustomer storageId={safeStorageId} customerId={safeCustomerId} />
        </>
    )
}

export default EditCustomer
